import { getApi } from './api';

// Create a singleton instance of the API client
export const apiClient = getApi();

export default apiClient;